import axios from "axios";
// const baseDomain = "https://localhost:44328/api/";//"https://jsonplaceholder.typicode.com";
  const baseDomain = "http://apiservice1.emersun.com/api/";

const baseURL = `${baseDomain}`;

const Repository = (token = '') => axios.create({
  baseURL,
  //headers:{'Autorization:"Bearer your token"'}
  headers: {
    'Autorization': `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyR3VpZCI6IjM3NTNiODFmLTM5ODEtNDA3YS1iYmNiLTA2MDdkYjBjYzI1NyIsImlzRXhpc3QiOiJGYWxzZSIsIlRpbWVPdXQtTWludXRlIjoiNjAiLCJuYmYiOjE2Mzc0NDIxMDYsImV4cCI6MTYzNzQ0NTcwNiwiaWF0IjoxNjM3NDQyMTA2fQ.FhmcVYYGKN0WELrnJqHgKrcsLotyPIWpYV6inv1AhFg`,
    'Content-Type': 'application/json; charset=UTF-8',
    "Access-Control-Allow-Origin": "*",
    'Access-Control-Allow-Headers': '*'
  }
});
const fetchImage = async (imageUrl) => {  
  const res = await fetch(`${baseURL}${imageUrl}`);
  const imageBlob = await res.blob();
  const imageObjectURL = URL.createObjectURL(imageBlob);
  return imageObjectURL;
};
export { Repository,fetchImage }

const NewRepository=(resource,payLoad,token)=>{
  return axios.post(`${baseURL}${resource}`,payLoad
  , {
    headers: {
      "Content-type": "application/json; charset=UTF-8",
      "Authorization": 'Bearer ' + token
    }
  })
}
export {NewRepository}

